<template>
  <Card size="large">
    <View direction="column" gap="md">
      <View justify="start" gap="sm" align="center">
        <Avatar variant="label-large" class="avatar" :userName="renter.user.name" />
        <Text variant="h2">{{ renter.user.name }}</Text>
      </View>

      <View direction="column" gap="sm" v-if="showings.length">
        <template v-for="showing in showings" :key="showing.id">
          <ShowingRequestCard
            v-for="showingRequest in showing.showingRequests"
            :key="showingRequest.id"
            class="showing-request-actions-card"
            :show-avatar="false"
            :property-id="showing.property.id"
            :property-address="showing.property.displayName"
            :property-photo="showing.property.coverImage"
            :showing-id="showing.id"
            :showing-agent-id="showing.showingAgent?.id"
            :showing-request-status="showingRequest.status"
            :showing-start-time="showing.startTime"
            :showing-end-time="showing.endTime"
            :showing-request="showingRequest"
            @showingRequestStatusChanged="handleShowingRequestStatusChanged"
          />
        </template>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, Avatar, View } from '@tallo/design-system';
import { ShowingRequestCard } from '@tallo/investor/showing';
import { RenterDto } from '@tallo/renter';

import { useRenterShowings } from '../composables/renter-showings';
import { useRenterProfileStore } from '../store/renter-profile.store';

const props = defineProps<{ renter: RenterDto }>();

const { showings } = useRenterShowings();
const renterProfileStore = useRenterProfileStore();

function handleShowingRequestStatusChanged() {
  renterProfileStore.loadInquiries(props.renter.id);
}
</script>

<style scoped lang="scss">
.avatar {
  width: 3rem;
  height: 3rem;
}
</style>
